import React, { useState, useEffect } from "react";
import { FileText, Check } from "lucide-react";
import api from "../cotizador/api";
const fmt = (n) => n != null ? "$ " + Math.round(n || 0).toLocaleString("es-AR") : "—";
const fmtDate = (d) => d ? new Date(d + "T12:00:00").toLocaleDateString("es-AR", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—";

function TortaAvance({ pct, size = 120, color = "#059669" }) {
  const r = 46, cx = 60, cy = 60;
  const p = Math.min(100, Math.max(0, pct));
  const rad = (p / 100) * 2 * Math.PI;
  const x = cx + r * Math.sin(rad), y = cy - r * Math.cos(rad);
  const large = p > 50 ? 1 : 0;
  const path = p >= 100
    ? `M ${cx} ${cy - r} A ${r} ${r} 0 1 1 ${cx - 0.001} ${cy - r} Z`
    : `M ${cx} ${cy} L ${cx} ${cy - r} A ${r} ${r} 0 ${large} 1 ${x} ${y} Z`;
  return (
    <svg width={size} height={size} viewBox="0 0 120 120">
      <circle cx={cx} cy={cy} r={r} fill="#f1f3f5" />
      {p > 0 && <path d={path} fill={color} opacity={0.85} />}
      <circle cx={cx} cy={cy} r={r * 0.6} fill="white" />
      <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle" fontSize="14" fontWeight="700" fill={color}>{p.toFixed(0)}%</text>
    </svg>
  );
}

function GanttReadonly({ presupuestoId }) {
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get(`/portal/gantt/${presupuestoId}`)
      .then(r => { setTareas(Array.isArray(r.data) ? r.data : []); setLoading(false); }).catch(() => setLoading(false));
  }, [presupuestoId]);
  if (loading) return <div style={{ color: "#6b7280", fontSize: 13, padding: 20 }}>Cargando planificación...</div>;
  if (!tareas.length) return <div style={{ color: "#6b7280", fontSize: 13, padding: 20 }}>Sin planificación cargada</div>;
  const fechas = tareas.map(t => new Date(t.fecha_inicio + "T12:00:00"));
  const fechasFin = tareas.map(t => { const fi = new Date(t.fecha_inicio + "T12:00:00"); fi.setDate(fi.getDate() + (t.duracion_dias || 1)); return fi; });
  const minDate = new Date(Math.min(...fechas)), maxDate = new Date(Math.max(...fechasFin));
  const totalDays = Math.max(1, Math.ceil((maxDate - minDate) / 86400000) + 1);
  return (
    <div style={{ overflowX: "auto" }}>
      <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 8 }}>{minDate.toLocaleDateString("es-AR")} → {maxDate.toLocaleDateString("es-AR")}</div>
      {tareas.map((t, i) => {
        const start = new Date(t.fecha_inicio + "T12:00:00");
        const left = Math.max(0, Math.ceil((start - minDate) / 86400000) / totalDays * 100);
        const width = Math.max(1, (t.duracion_dias || 1)) / totalDays * 100;
        return (
          <div key={i} style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 11, color: "#1a1a2e", marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.nombre}</div>
            <div style={{ height: 20, background: "#f1f3f5", borderRadius: 4, position: "relative", border: "1px solid #e0e0e8" }}>
              <div style={{ position: "absolute", left: left + "%", width: width + "%", height: "100%", borderRadius: 3, background: t.color || "#7c3aed", opacity: 0.85, minWidth: 4 }} />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function ClientePortal({ user, clienteId, clienteNombre, onLogout, token: tokenProp }) {
  const [presupuestos, setPresupuestos] = useState([]);
  const [presSelec, setPresSelec] = useState(null);
  const [tab, setTab] = useState("avance");
  const [certs, setCerts] = useState([]);
  const [cobros, setCobros] = useState([]);
  const [contrato, setContrato] = useState(null);
  const [etapas, setEtapas] = useState(null);   // etapas pactadas del trabajo
  const [planos, setPlanos] = useState([]);
  const [verPlano, setVerPlano] = useState(null);
  const [comentarios, setComentarios] = useState([]);
  const [nuevoComentario, setNuevoComentario] = useState("");
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [aceptando, setAceptando] = useState(false);
  const [toast, setToast] = useState("");
  const [seccionesVisibles, setSeccionesVisibles] = useState(["avance","contrato","cobros","gantt","consultas"]);

  const showToast = (m) => { setToast(m); setTimeout(() => setToast(""), 3000); };

  const tenantNombre = (() => { try { const t = JSON.parse(localStorage.getItem("obras_tenant") || "null"); return t?.nombre || "FAIM OBRAS"; } catch { return "FAIM OBRAS"; } })();
  const tenantColor = (() => { try { const t = JSON.parse(localStorage.getItem("obras_tenant") || "null"); return t?.color_primario || "#059669"; } catch { return "#059669"; } })();
  const tenantLogo = (() => { try { const t = JSON.parse(localStorage.getItem("obras_tenant") || "null"); return t?.logo_url || null; } catch { return null; } })();

  useEffect(() => {
    // Esperar un tick para que el token se propague al localStorage
    const doFetch = () => {
      api.get('/portal/presupuestos')
        .then(r => {
          const pres = Array.isArray(r.data) ? r.data : [];
          setPresupuestos(pres);
          if (pres.length > 0) setPresSelec(pres[0]);
          setLoading(false);
        }).catch(() => setLoading(false));
    };

    const loadConfig = () => {
      api.get('/portal/mi-config')
        .then(r => { if (r.data?.secciones_visibles) setSeccionesVisibles(r.data.secciones_visibles); })
        .catch(() => {});
    };
    if (tokenProp) {
      localStorage.setItem("obras_token", tokenProp);
      loadConfig();
      doFetch();
    } else {
      setTimeout(() => {
        if (localStorage.getItem("obras_token")) doFetch();
        else setLoading(false);
      }, 500);
    }
  }, [tokenProp]);

  useEffect(() => {
    if (!presSelec) return;
    const id = presSelec.id;
    api.get(`/presupuestos/${id}/certificados`).then(r => setCerts(r.data?.certificados || (Array.isArray(r.data) ? r.data : []))).catch(() => {});
    api.get(`/presupuestos/${id}/cobros`).then(r => setCobros(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    api.get(`/presupuestos/${id}/contrato`).then(r => setContrato(r.data)).catch(() => {});
    api.get(`/portal/comentarios/${id}`).then(r => setComentarios(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    setEtapas(null);
    api.get(`/portal/etapas/${id}`).then(r => setEtapas(r.data)).catch(() => setEtapas({ etapas: [] }));
    api.get(`/portal/archivos/${id}`).then(r => setPlanos(Array.isArray(r.data) ? r.data : [])).catch(() => setPlanos([]));
  }, [presSelec]);

  const enviarComentario = async () => {
    if (!nuevoComentario.trim() || !presSelec) return;
    setEnviando(true);
    await api.post('/portal/comentarios', { presupuesto_id: presSelec.id, texto: nuevoComentario, nombre: clienteNombre || user?.nombre, email: user?.email });
    setNuevoComentario("");
    const d = await api.get(`/portal/comentarios/${presSelec.id}`).then(r => r.data).catch(() => []);
    setComentarios(Array.isArray(d) ? d : []);
    setEnviando(false);
    showToast("✓ Mensaje enviado");
  };

  const aceptarContrato = async () => {
    if (!contrato || !presSelec) return;
    setAceptando(true);
    try {
      await api.post(`/presupuestos/${presSelec.id}/contrato/aceptar`, { nombre_cliente: clienteNombre || user?.nombre, email_cliente: user?.email });
      setContrato(prev => ({ ...prev, estado: "aceptado", aceptado_en: new Date().toISOString() }));
      showToast("✓ Contrato aceptado correctamente");
    } catch {}
    setAceptando(false);
  };

  const ultimoCert = certs.length > 0 ? certs[certs.length - 1] : null;
  const avancePct = ultimoCert ? parseFloat(ultimoCert.avance_total_pct || 0) : 0;
  const totalCobrado = cobros.reduce((s, c) => s + parseFloat(c.monto || 0), 0);
  const totalCertificado = parseFloat(ultimoCert?.monto_acumulado || 0);
  const saldoPendiente = totalCertificado - totalCobrado;

  const card = { background: "#fff", border: "1px solid #e0e0e8", borderRadius: 10, padding: 16, marginBottom: 10 };
  const inp = { width: "100%", boxSizing: "border-box", padding: "8px 12px", background: "#f1f3f5", border: "1px solid #e0e0e8", borderRadius: 8, color: "#1a1a2e", fontSize: 13, fontFamily: "inherit", outline: "none" };

  const ALL_TABS = [
    { id: "avance", label: "Avance" },
    { id: "etapas", label: "Etapas" },
    { id: "planos", label: "Planos" },
    { id: "contrato", label: "Contrato" },
    { id: "cobros", label: "Cuenta corriente" },
    { id: "gantt", label: "Planificación" },
    { id: "consultas", label: "Consultas" },
  ];
  // Las secciones se guardan como lista blanca por acceso. Una seccion nueva
  // no esta en las listas ya creadas, asi que quedaria invisible para siempre
  // para todo cliente dado de alta antes: por eso las nuevas se muestran salvo
  // que el estudio las apague expresamente.
  const SECCIONES_NUEVAS = ["etapas", "planos"];
  const TABS = ALL_TABS.filter(t => seccionesVisibles.includes(t.id) || SECCIONES_NUEVAS.includes(t.id));

  // Si el tab activo no está visible, cambiar al primero disponible
  useEffect(() => {
    if (TABS.length > 0 && !TABS.some(t => t.id === tab)) {
      setTab(TABS[0].id);
    }
  }, [seccionesVisibles]);

  if (loading) return (
    <div style={{ minHeight: "100dvh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f8f9fa" }}>
      <div style={{ textAlign: "center" }}>
        {tenantLogo ? <img src={tenantLogo} alt="logo" style={{ height: 48, objectFit: "contain", marginBottom: 16 }} /> : <div style={{ fontSize: 24, fontWeight: 900, color: tenantColor, marginBottom: 8 }}>{tenantNombre}</div>}
        <div style={{ color: "#6b7280", fontSize: 14 }}>Cargando...</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: "100dvh", background: "#f8f9fa", fontFamily: "'Syne', sans-serif", color: "#1a1a2e" }}>
      {/* Header */}
      <div style={{ background: "#fff", borderBottom: "1px solid #e0e0e8", padding: "12px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 50 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {tenantLogo
            ? <img src={tenantLogo} alt="logo" style={{ height: 32, objectFit: "contain" }} />
            : <div style={{ fontSize: 18, fontWeight: 900, color: tenantColor }}>{tenantNombre}</div>
          }
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span style={{ fontSize: 13, color: "#6b7280" }}>{clienteNombre || user?.nombre}</span>
          <button onClick={onLogout} style={{ fontSize: 12, color: "#6b7280", background: "none", border: "none", cursor: "pointer" }}>Salir</button>
        </div>
      </div>

      {/* Selector de obra */}
      {presupuestos.length > 1 && (
        <div style={{ background: "#fff", borderBottom: "1px solid #e0e0e8", padding: "8px 20px", display: "flex", gap: 8, flexWrap: "wrap" }}>
          {presupuestos.map(p => (
            <button key={p.id} onClick={() => setPresSelec(p)} style={{ padding: "5px 14px", borderRadius: 20, border: `1px solid ${presSelec?.id === p.id ? tenantColor : "#e0e0e8"}`, background: presSelec?.id === p.id ? tenantColor + "12" : "transparent", color: presSelec?.id === p.id ? tenantColor : "#6b7280", fontSize: 12, cursor: "pointer", fontFamily: "inherit" }}>
              {p.nombre_obra}
            </button>
          ))}
        </div>
      )}

      {/* Tabs */}
      <div style={{ background: "#fff", borderBottom: "1px solid #e0e0e8", display: "flex", padding: "0 20px", overflowX: "auto" }}>
        {TABS.map(({ id, label }) => (
          <button key={id} onClick={() => setTab(id)} style={{ padding: "12px 14px", background: "none", border: "none", borderBottom: `2px solid ${tab === id ? tenantColor : "transparent"}`, color: tab === id ? tenantColor : "#6b7280", cursor: "pointer", fontSize: 13, fontWeight: tab === id ? 700 : 400, fontFamily: "inherit", whiteSpace: "nowrap" }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ maxWidth: 700, margin: "0 auto", padding: "20px 16px 60px" }}>
        {!presSelec ? (
          <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 60 }}>Sin proyectos asignados</div>
        ) : (
          <>
            {/* ── AVANCE ── */}
            {tab === "avance" && (
              <>
                <div style={{ ...card, display: "flex", gap: 20, alignItems: "center", flexWrap: "wrap" }}>
                  <TortaAvance pct={avancePct} color={tenantColor} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>{presSelec.nombre_obra}</div>
                    {presSelec.ubicacion && <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 8 }}>{presSelec.ubicacion}</div>}
                    <div style={{ fontSize: 13, marginBottom: 4 }}><span style={{ color: "#6b7280" }}>Avance: </span><span style={{ fontWeight: 700, color: tenantColor }}>{avancePct.toFixed(1)}%</span></div>
                    {presSelec.total_precio_con_iva > 0 && <div style={{ fontSize: 13 }}><span style={{ color: "#6b7280" }}>Presupuesto: </span><span style={{ fontWeight: 700 }}>{fmt(presSelec.total_precio_con_iva)}</span></div>}
                  </div>
                </div>

                {certs.length > 0 ? (
                  <div style={card}>
                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Certificados de avance</div>
                    {certs.map(cert => (
                      <div key={cert.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f3f5" }}>
                        <div>
                          <div style={{ fontSize: 13, fontWeight: 600 }}>Certificado Nº {cert.numero}</div>
                          <div style={{ fontSize: 12, color: "#6b7280" }}>{fmtDate(cert.fecha)} · {parseFloat(cert.avance_total_pct || 0).toFixed(1)}% avance</div>
                        </div>
                        <div style={{ textAlign: "right" }}>
                          <div style={{ fontSize: 14, fontWeight: 700, color: tenantColor }}>{fmt(cert.total_periodo || cert.monto_periodo)}</div>
                          <div style={{ fontSize: 11, color: "#6b7280" }}>Acum: {fmt(cert.monto_acumulado)}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 32 }}>Sin certificados emitidos aún</div>
                )}
              </>
            )}

            {/* ── ETAPAS ── */}
            {tab === "etapas" && (
              <div>
                {!etapas ? (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 60 }}>Cargando…</div>
                ) : (etapas.etapas || []).length === 0 ? (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 48 }}>
                    Todavía no hay etapas acordadas para este trabajo.
                  </div>
                ) : (
                  <>
                    <div style={{ ...card, display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(140px,1fr))", gap: 12 }}>
                      {[["Pactado", etapas.total_pactado, "#1a1a2e"],
                        ["Cumplido", etapas.total_devengado, tenantColor],
                        ["Pagaste", etapas.total_cobrado, "#059669"]].map(([l, v, col]) => (
                        <div key={l}>
                          <div style={{ fontSize: 10, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 5 }}>{l}</div>
                          <div style={{ fontSize: 18, fontWeight: 800, color: col, fontFamily: "'IBM Plex Mono',monospace" }}>{fmt(v || 0)}</div>
                        </div>
                      ))}
                    </div>
                    <div style={card}>
                      {etapas.etapas.map(e => (
                        <div key={e.numero} style={{ padding: "12px 0", borderBottom: "1px solid #f1f3f5" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", gap: 10, flexWrap: "wrap", alignItems: "baseline" }}>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: 14, fontWeight: 700 }}>Etapa {e.numero}</div>
                              <div style={{ fontSize: 12.5, color: "#6b7280", marginTop: 2 }}>{e.descripcion}</div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontSize: 15, fontWeight: 700, fontFamily: "'IBM Plex Mono',monospace" }}>{fmt(e.monto)}</div>
                              <div style={{ fontSize: 11, color: e.saldo > 0 ? "#d97706" : "#059669" }}>
                                {e.saldo > 0 ? `Falta pagar ${fmt(e.saldo)}` : "Pagada"}
                              </div>
                            </div>
                          </div>
                          <div style={{ height: 8, background: "#f1f3f5", borderRadius: 4, overflow: "hidden", marginTop: 9 }}>
                            <div style={{ height: "100%", width: `${Math.min(100, e.avance_pct || 0)}%`, background: tenantColor, borderRadius: 4, transition: "width .5s" }} />
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 5, fontSize: 11, color: "#6b7280" }}>
                            <span>{Number(e.avance_pct || 0).toFixed(0)}% · {e.estado}</span>
                            <span>{e.fecha_real ? `Cumplida ${fmtDate(e.fecha_real)}` : e.fecha_vencimiento ? `Prevista ${fmtDate(e.fecha_vencimiento)}` : ""}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            )}

            {/* ── PLANOS ── */}
            {tab === "planos" && (
              <div>
                {planos.length === 0 ? (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 48 }}>
                    Todavía no hay planos publicados para esta obra.
                  </div>
                ) : (
                  <div style={card}>
                    {planos.map(a => (
                      <div key={a.id} style={{ display: "flex", justifyContent: "space-between", gap: 10, padding: "12px 0", borderBottom: "1px solid #f1f3f5", alignItems: "center" }}>
                        <div style={{ minWidth: 0 }}>
                          <div style={{ fontSize: 13.5, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.nombre}</div>
                          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 2 }}>
                            {(a.bytes / 1024 / 1024).toFixed(1)} MB · {String(a.created_at).slice(0, 10)}
                          </div>
                        </div>
                        <button onClick={() => setVerPlano(a)}
                          style={{ padding: "6px 14px", background: "none", border: `1px solid ${tenantColor}`, borderRadius: 8, fontSize: 12.5, color: tenantColor, cursor: "pointer", fontFamily: "inherit", flexShrink: 0 }}>
                          Ver
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ── CONTRATO ── */}
            {tab === "contrato" && (
              <div>
                {!contrato ? (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 60 }}>
                    <FileText size={32} strokeWidth={1} color="#9ca3af" style={{ marginBottom: 12 }} />
                    <div style={{ fontWeight: 600 }}>Sin contrato generado aún</div>
                  </div>
                ) : (
                  <div style={card}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
                      <div>
                        <div style={{ fontSize: 16, fontWeight: 700 }}>Contrato de obra</div>
                        <div style={{ fontSize: 13, color: "#6b7280" }}>{presSelec.nombre_obra}</div>
                      </div>
                      <div style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, fontWeight: 700, background: contrato.estado === "aceptado" ? "#f0fdf4" : contrato.estado === "firmado" ? "#eff6ff" : "#fffbeb", color: contrato.estado === "aceptado" ? "#059669" : contrato.estado === "firmado" ? "#1d4ed8" : "#d97706" }}>
                        {contrato.estado === "aceptado" ? <span style={{display:"flex",alignItems:"center",gap:3}}><Check size={12} strokeWidth={2.5} /> Aceptado</span> : contrato.estado === "firmado" ? "Firmado" : contrato.estado === "enviado" ? "Pendiente de aceptación" : "Borrador"}
                      </div>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                      {[
                        ["Monto total", fmt(contrato.monto_total)],
                        ["Forma de pago", contrato.tipo_pago === "por_certificado" ? "Por certificado" : contrato.tipo_pago === "desembolsos" ? "Por desembolsos" : "Mixto"],
                        ["Anticipo", contrato.anticipo_pct ? `${contrato.anticipo_pct}%` : "Sin anticipo"],
                        ["Plazo", contrato.plazo_obra_dias ? `${contrato.plazo_obra_dias} días` : "—"],
                        ["Lugar", contrato.lugar_ejecucion || "—"],
                        ["Fecha de firma", fmtDate(contrato.fecha_firma)],
                      ].map(([label, value]) => (
                        <div key={label}>
                          <div style={{ fontSize: 10, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</div>
                          <div style={{ fontSize: 14, fontWeight: 600 }}>{value}</div>
                        </div>
                      ))}
                    </div>

                    {contrato.clausulas_adicionales && (
                      <div style={{ marginBottom: 16, padding: "12px 14px", background: "#f8f9fa", borderRadius: 8 }}>
                        <div style={{ fontSize: 11, color: "#6b7280", textTransform: "uppercase", marginBottom: 6 }}>Cláusulas adicionales</div>
                        <div style={{ fontSize: 13, whiteSpace: "pre-line" }}>{contrato.clausulas_adicionales}</div>
                      </div>
                    )}

                    {(contrato.desembolsos || []).length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        <div style={{ fontSize: 12, fontWeight: 700, color: "#6b7280", textTransform: "uppercase", marginBottom: 8 }}>Calendario de pagos</div>
                        {contrato.desembolsos.map(d => (
                          <div key={d.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f3f5" }}>
                            <div>
                              <span style={{ fontSize: 13, fontWeight: 600 }}>Cuota {d.numero}</span>
                              <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>{d.descripcion}</span>
                            </div>
                            <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
                              <span style={{ fontSize: 12, color: "#6b7280" }}>{fmtDate(d.fecha_vencimiento)}</span>
                              <span style={{ fontWeight: 700, fontFamily: "'IBM Plex Mono',monospace" }}>{fmt(d.monto)}</span>
                              <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 10, background: d.estado === "cobrado" ? "#f0fdf4" : "#fef3c7", color: d.estado === "cobrado" ? "#059669" : "#d97706" }}>{d.estado}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Botón aceptar */}
                    {(contrato.estado === "enviado" || contrato.estado === "borrador") && (
                      <div style={{ marginTop: 16, padding: "16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: 10, textAlign: "center" }}>
                        <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 12 }}>
                          Al aceptar este contrato confirmás que leíste y acordás con los términos indicados.
                        </div>
                        <button onClick={aceptarContrato} disabled={aceptando} style={{ padding: "10px 24px", background: tenantColor, color: "#fff", border: "none", borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: "pointer", fontFamily: "inherit" }}>
                          {aceptando ? "Procesando..." : <span style={{display:"flex",alignItems:"center",gap:4}}><Check size={13} strokeWidth={2.5} /> Aceptar contrato</span>}
                        </button>
                      </div>
                    )}
                    {contrato.estado === "aceptado" && contrato.aceptado_en && (
                      <div style={{ fontSize: 12, color: "#059669", textAlign: "center", marginTop: 8 }}>
                        Aceptado el {new Date(contrato.aceptado_en).toLocaleDateString("es-AR")}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}

            {/* ── CUENTA CORRIENTE ── */}
            {tab === "cobros" && (
              <div>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
                  {[
                    ["Certificado acumulado", fmt(totalCertificado), "#7c3aed"],
                    ["Cobrado", fmt(totalCobrado), "#059669"],
                    ["Saldo pendiente", fmt(saldoPendiente), saldoPendiente > 0 ? "#ef4444" : "#059669"],
                  ].map(([label, value, color]) => (
                    <div key={label} style={{ background: "#fff", border: "1px solid #e0e0e8", borderRadius: 10, padding: 14 }}>
                      <div style={{ fontSize: 10, color: "#6b7280", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>{label}</div>
                      <div style={{ fontSize: 18, fontWeight: 800, color, fontFamily: "'IBM Plex Mono',monospace" }}>{value}</div>
                    </div>
                  ))}
                </div>
                {cobros.length === 0 ? (
                  <div style={{ ...card, textAlign: "center", color: "#6b7280", padding: 40 }}>Sin cobros registrados</div>
                ) : (
                  <div style={card}>
                    <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Historial de cobros</div>
                    {cobros.map(c => (
                      <div key={c.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #f1f3f5" }}>
                        <div>
                          <div style={{ fontSize: 13 }}>{c.forma_pago}</div>
                          <div style={{ fontSize: 11, color: "#6b7280" }}>{fmtDate(c.fecha)} {c.referencia ? `· ${c.referencia}` : ""} {c.nota ? `· ${c.nota}` : ""}</div>
                        </div>
                        <div style={{ fontWeight: 700, color: "#059669", fontFamily: "'IBM Plex Mono',monospace" }}>{fmt(c.monto)}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ── GANTT ── */}
            {tab === "gantt" && (
              <div style={card}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>Planificación</div>
                <GanttReadonly presupuestoId={presSelec.id} />
              </div>
            )}

            {/* ── CONSULTAS ── */}
            {tab === "consultas" && (
              <div style={card}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 16 }}>Consultas y mensajes</div>
                {comentarios.length === 0 && <div style={{ color: "#6b7280", fontSize: 13, marginBottom: 16 }}>Sin mensajes todavía. Escribí tu consulta abajo.</div>}
                <div style={{ maxHeight: 350, overflowY: "auto", marginBottom: 16 }}>
                  {comentarios.map((com, i) => (
                    <div key={i} style={{ marginBottom: 10, padding: "10px 12px", borderRadius: 8, background: com.es_admin ? "#f1f3f5" : tenantColor + "12", border: "1px solid #e0e0e8" }}>
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4 }}>{com.nombre || com.email} · {com.created_at ? new Date(com.created_at).toLocaleDateString("es-AR") : ""}</div>
                      <div style={{ fontSize: 13 }}>{com.texto}</div>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input style={{ ...inp, flex: 1 }} placeholder="Escribí tu consulta..." value={nuevoComentario} onChange={e => setNuevoComentario(e.target.value)} onKeyDown={e => e.key === "Enter" && enviarComentario()} />
                  <button onClick={enviarComentario} disabled={enviando || !nuevoComentario.trim()} style={{ padding: "8px 16px", background: tenantColor, color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", opacity: !nuevoComentario.trim() ? 0.5 : 1 }}>
                    {enviando ? "..." : "Enviar"}
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {/* Visor: el navegador renderiza PDFs e imagenes solo, sin libreria */}
      {verPlano && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 400, display: "flex", flexDirection: "column" }}
          onClick={() => setVerPlano(null)}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", color: "#fff", gap: 12 }}
            onClick={e => e.stopPropagation()}>
            <div style={{ fontSize: 13.5, fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{verPlano.nombre}</div>
            <button onClick={() => setVerPlano(null)}
              style={{ background: "none", border: "none", color: "#fff", fontSize: 26, cursor: "pointer", lineHeight: 1 }}>×</button>
          </div>
          <div style={{ flex: 1, padding: "0 12px 12px" }} onClick={e => e.stopPropagation()}>
            {String(verPlano.mime || "").startsWith("image/") ? (
              <img src={verPlano.url} alt={verPlano.nombre} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            ) : (
              <iframe src={verPlano.url} title={verPlano.nombre}
                style={{ width: "100%", height: "100%", border: "none", borderRadius: 8, background: "#fff" }} />
            )}
          </div>
        </div>
      )}

      {toast && (
        <div style={{ position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)", background: "#1a1a2e", color: "#fff", borderRadius: 20, padding: "10px 20px", fontSize: 13, zIndex: 999 }}>
          {toast}
        </div>
      )}
    </div>
  );
}
